<div *ngIf="isSideCartOpen()" class="backdrop" (click)="toggleSideCart.emit()"></div>
<div [class.open]="isSideCartOpen()" class="side-cart">
    <div class="side-cart-header">
        <h3>Your Cart</h3>
        <button (click)="emitToggleSideCart()">Close</button>
    </div>
    <div class="side-cart-content">
        <ng-container *ngIf="cart() as cartData; else loading">
            <ng-container *ngIf="cartData; else emptyCart">
                <ul *ngIf="cartData.cartItems.length > 0; else emptyCart">
                    <li *ngFor="let item of cartData.cartItems" class="cart-item">
                        <img [ngSrc]="getEntityImage(item)" alt="item" height="60" width="60">
                        <div class="item-details">
                            <span class="item-name">{{ getEntityName(item) }}</span>
                            <span [class.free]="item.is_free" class="item-price">{{ getItemDisplayPrice(item) }}</span>
                            <div *ngIf="item.entity_type !== 'Course' && !item.is_free" class="quantity-controls">
                                <button (click)="updateQuantity(item, -1)">-</button>
                                <span>{{ item.quantity }}</span>
                                <button (click)="updateQuantity(item, 1)">+</button>
                            </div>
                            <div *ngIf="item.entity_type === 'Course' || item.is_free">
                                <span>Quantity: 1 (Fixed)</span>
                            </div>
                            <div *ngIf="item.entity_type === 'Event' && getTimerValue(item.uuid) as timerValue"
                                 class="timer">
                                Time left: {{ timerValue | timer }}
                            </div>
                        </div>
                        <button (click)="removeItem(item.uuid)" class="remove-btn" title="Remove Item">
                            <i class="bi bi-trash"></i>
                        </button>
                    </li>
                </ul>
            </ng-container>
        </ng-container>

        <ng-template #emptyCart>
            <div class="empty-cart">Your cart is empty</div>
        </ng-template>
        <ng-template #loading>
            <div class="empty-cart">Loading...</div>
        </ng-template>
    </div>
    <div *ngIf="cart() as cartData" class="cart-footer">
        <ng-container *ngIf="cartData && cartData.cartItems.length > 0">
            <p>Total: {{ cartData.total | currency:'INR' }}</p>
            <button (click)="emitToggleSideCart()" class="checkout-btn" routerLink="/checkout">
                Proceed to Checkout
            </button>
        </ng-container>
    </div>
</div>
